export const citiesMap = {
  austin: "Austin, TX",
  brooklyn: "Brooklyn, NY",
  dunedin: "Dunedin, FL",
  dallas: "Dallas, TX",
  oak_ridge_north: "Oak Ridge North, TX",
  houston: "Houston, TX",
  jupiter: "Jupiter, FL",
  chicago: "Chicago, IL",
  tampa : "Tampa Bay, FL",
  lakeland: "Lakeland, FL",
  scottsdale: "Scottsdale, AZ",
  southlake: "Southlake, TX",
  boca_raton: "Boca Raton, FL",
  los_angeles: "Los Angeles, CA",
  lake_park: "Lake Park, FL",
  rosemont: "Rosemont, IL",
  new_york: "New York, NY",
  irving: "Irving, TX",
  stpetersburg: "St. Petersburg, FL",
  riverview: "Riverview, FL",
  phoenix: "Phoenix, AZ",
  boynton_back: "Boynton Beach, FL",
  west_palm_beach: "West Palm Beach, FL",
  delray_beach: "Delray Beach, FL",
  georgetown: "Georgetown, TX",
  san_antonio: "San Antonio, TX",
  friendswood: "Friendswood, TX",
  gilbert: "Gilbert, AZ",
  mesa: "Mesa, AZ",
  round_rock: "Round Rock, TX",
  palm_beach: "Palm Beach, FL",
  dfw: "DFW, TX",
};
